module.exports = __webpack_public_path__ + "img/images/new-landing/googleplay.svg?a5b28d23";